import { Routes, Route, Navigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { Toaster } from "@/components/ui/sonner";

// Pages
import Home from './pages/Home';
import LoginPage from './pages/Login';
import SignupPage from './pages/Signup';
import AboutPage from './pages/About';
import ContactPage from './pages/Contact';
import AdminPage from './app/admin/page';
import EntrepreneurPage from './app/entrepreneur/page';
import InvestorPage from './app/investor/page';
import CompanyPage from '@/pages/CompanyPage';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import ChatWithAmrish from '@/pages/ChatWithAmrish';
import ScheduleCall from '@/pages/ScheduleCall';

// Components
import ProtectedRoute from './components/ProtectedRoute';
import RoleRedirect from './components/RoleRedirect';
import OnboardingWizard from './components/onboarding/OnboardingWizard';

// Utils
import { setupDatabase } from './utils/setupDatabase';

function App() {
  const [isMounted, setIsMounted] = useState(false);

  // Initialize and check database on app load
  useEffect(() => {
    setupDatabase();
    setIsMounted(true);
  }, []);

  return (
    <>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/company/:id" element={<CompanyPage />} />
        <Route path="/company/:id/edit" element={<CompanyPage isEditing={true} />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/login/redirect" element={<RoleRedirect />} />
        <Route path="/chat-with-amrish" element={<ChatWithAmrish />} />
        <Route path="/schedule-call" element={
          <ProtectedRoute allowedRoles={['investor']}>
            <ScheduleCall />
          </ProtectedRoute>
        } />

        {/* Protected onboarding route */}
        <Route path="/onboarding" element={
          <ProtectedRoute allowedRoles={['admin', 'investor', 'entrepreneur']}>
            <OnboardingWizard />
          </ProtectedRoute>
        } />

        {/* Protected admin routes */}
        <Route path="/admin/*" element={
          <ProtectedRoute allowedRoles={['admin']}>
            <AdminPage />
          </ProtectedRoute>
        } />

        {/* Protected entrepreneur routes */}
        <Route path="/entrepreneur/*" element={
          <ProtectedRoute allowedRoles={['entrepreneur']}>
            <EntrepreneurPage />
          </ProtectedRoute>
        } />
        <Route path="/dashboard" element={
          <ProtectedRoute allowedRoles={['entrepreneur']}>
            <EntrepreneurPage />
          </ProtectedRoute>
        } />

        {/* Protected investor routes */}
        <Route path="/investor/*" element={
          <ProtectedRoute allowedRoles={['investor']}>
            <InvestorPage />
          </ProtectedRoute>
        } />

        {/* Redirect all other routes to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      {isMounted && <Toaster />}
    </>
  );
}

export default App;
